// extracted by mini-css-extract-plugin
module.exports = {"power-independence-F":"F_power-independence-F__ftHQs"};